<app-modal-filler-atom
  (click)="closeAdvertising()"
  [index]="(index$ | async) + 10"
></app-modal-filler-atom>
<div
  class="fixed right-0 left-0 shadow overflow-y-auto"
  [ngClass]="
    (settingsSelector.isMobileScreen | async)
      ? 'bottom-0 max-h-85-screen max-w-screen-sm rounded-t-3xl'
      : 'flex justify-center items-center w-full h-full top-0 left-0'
  "
  [style.z-index]="(index$ | async) + 60"
>
  <div class="p-5 bg-white md:rounded-3xl">
    <div class="flex justify-between items-center">
      <h2 class="font-accent font-bold text-3xs mx-auto">
        {{ shopOpensAt }}
      </h2>
    </div>
    <p
      *ngIf="distributionMode$ | async as distribution"
      class="w-full text-center my-2 text-neutral-600 font-base"
    >
      {{ 'capabilities.the-order' | translate }}
      {{ 'capabilities.not-available' | translate }}.
    </p>
    <div class="pt-1 w-full">
      <app-button-atom
        size="M"
        [label]="'capabilities.see-the-products' | translate"
        color="primary"
        (click)="closeAdvertising()"
        type="light"
        [full]="true"
      ></app-button-atom>
    </div>
  </div>
</div>
